import { notification, Modal, Select } from "antd";
import { useCallback, useState, useEffect, useMemo } from 'react';
import { withLocale } from '../../l10n';
import service from "../../services/Service";

const { Option } = Select;

function SpareModal({ lang, showModal, closeSpareModal, navigate, id_stock }) {

  // ===== 1. ESTADOS =====
  const [loading, setLoading] = useState(true);

  const [data, setData] = useState({
    datos: [],
    uuid: null,
    id_spare: null
  });

  const workOrders = useMemo(() => data.datos?.map(item => ({
    uuid: item.uuid,
    ki_id: item.ki_id
  })) || [], [data.datos]);

  // ===== 2. HELPERS (Para actualizar estado) =====
  const updateData = (field, value) => setData(prev => ({ ...prev, [field]: value }));

  // ===== 3. FUNCIONES PRINCIPALES =====
  const Pfetch = useCallback(async () => {
    setLoading(true);
    try {
      const res = await service.get('boards?state=Terminado&original=true');
      let datos = [];
      
      if (res.data.ok === false) {
        notification["error"]({
          message: lang.handle(res.data.message),
        });
      } else {
        datos = res.data;
      }
      updateData('datos', datos);
    } catch (error) {
      console.error("Error:", error);
      notification["error"]({
        message: lang.handle("Error al obtener datos"),
      });
    } finally {
      setLoading(false);
    }
  }, [lang]);


  // ===== 4. HANDLERS =====
  const updateSpare = () => {
    navigate(`/boards/edit/3/${data.id_spare}/${id_stock}`);
  };

  const handleSelectChange = useCallback((value) => {
    if (!value) {
      updateData('uuid', null);
      updateData('id_spare', null);
    } else {
      const selectedOrder = workOrders.find(order => order.uuid === value);
      if (selectedOrder) {
        updateData('uuid', value);
        updateData('id_spare', selectedOrder.ki_id);
      }
    }
  }, [workOrders]);

  // ===== 5. EFFECTS =====
  useEffect(() => {
    if (showModal) {
      Pfetch();
    }
  }, [showModal, Pfetch]);


  // ===== 6. RENDER =====

  return (
    <Modal
      loading={loading}
      width = {'30%'}
      centered = {true}
      closable={false}
      open={showModal}
      styles = {{body: {height: "15vh"}}}
      title = {lang.handle('Sustitución de Kibox')}
      onCancel = {closeSpareModal}
      cancelText = {lang.handle('Cerrar')}
      onOk = {updateSpare}
      okText = {lang.handle('Continuar')}
      okButtonProps={{ disabled: !data.uuid }}
    >
      <Select
        placeholder = {lang.handle("Selecciona el UUID del kibox a sustituir")}
        style = {{ width: "100%", marginBottom: "20px" }}
        value = {data.uuid}
        showSearch
        onChange = {handleSelectChange}
        allowClear
      >
        {workOrders.map((order) => (
          <Option key={order.uuid} value={order.uuid}>
            {order.uuid}
          </Option>
        ))}
      </Select>
    </Modal>
  );
};

export default withLocale(SpareModal);
